<template>
  <b-navbar toggleable="sm" variant="dark" type="dark" sticky>

    <b-navbar-brand href="#">webcg-studio</b-navbar-brand>

    <b-nav-toggle toggleable="false" target="nav_collapse" right></b-nav-toggle>
    <b-collapse is-nav id="nav_collapse" v-if="loaded">
      <b-navbar-nav>
        <b-nav-item-dropdown text="New">
          <b-dropdown-item v-if="hasLibraryRole" href="#" @click="openTemplateSelection()">Template Library...</b-dropdown-item>
          <div class="dropdown-divider" v-if="hasLibraryRole && userTemplates && userTemplates.length"></div>
          <b-dropdown-item href="#" v-for="t in userTemplates"
                           @click="addTemplate(t)" v-html="t.name"></b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown :text="name || 'Templates'" v-for="(templates, name) in folders" :key="name">
          <b-dropdown-item href="#" v-for="template in templates" :key="template.templateId"
                           @click="openTemplate(template.templateId)" v-html="template.name"></b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Datasets">
          <b-dropdown-item href="#" v-for="dataset in datasets" :key="dataset.datasetId"
                           @click="openDataset(dataset.datasetId)" v-html="dataset.name"></b-dropdown-item>
          <div class="dropdown-divider" v-if="datasets && datasets.length"></div>
          <b-dropdown-item href="#" @click="addDatasetExcel()">New Excel-Dataset</b-dropdown-item>
          <b-dropdown-item href="#" @click="addDatasetRaceResult('race-result-dataset-window')" v-if="isRaceResult">New Race Result Dataset</b-dropdown-item>
          <b-dropdown-item href="#" @click="addDatasetUiaa('uiaa-dataset-window')" v-if="isUiaa">New UIAA Results Center Dataset</b-dropdown-item>
          <b-dropdown-item href="#" @click="addDatasetUiaa('vertical-life-dataset-window')" v-if="isUiaa">New Vertical Life Dataset</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Albums">
          <b-dropdown-item href="#" v-for="album in albums" :key="album.albumId"
                           @click="openAlbum(album.albumId)" v-html="album.name"></b-dropdown-item>
          <div class="dropdown-divider" v-if="albums && albums.length"></div>
          <b-dropdown-item href="#" @click="addAlbum()">New Album</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown text="Windows">
          <b-dropdown-item href="#" v-for="window in windows" :key="window.windowId"
                           @click="openWindow(window.windowId)">{{ window.title }}
          </b-dropdown-item>
          <div class="dropdown-divider" v-if="windows && windows.length"></div>
          <b-dropdown-item href="#" @click="addProducer('Preview', 'preview')">New Preview</b-dropdown-item>
          <b-dropdown-item href="#" @click="addProducer('Program', 'program')">New Program</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template slot="button-content">
            {{ username }}
          </template>
          <b-dropdown-item href="#" @click="logout()">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
</template>

<script>
  import * as action from '../store/action-types'
  import * as mutation from '../store/mutation-types'
  import TemplateDefinitionsService from '../services/template-definitions.service'
  import Vue from 'vue'

  export default {
    name: 'navbar',
    created: function () {
      this.templateDefinitionsService = new TemplateDefinitionsService(this.$keycloak, this.$store)
    },
    computed: {
      loaded () {
        return !this.$store.getters.loading
      },
      userTemplates () {
        const templates = this.templateDefinitionsService.getTemplateDefinitions().filter(p => !p.hidden)
        templates.sort((a, b) => {
          // if a.sortOrder or b.sortOrder is a number
          if (!isNaN(a.sortOrder) || !isNaN(b.sortOrder)) {
            if (isNaN(a.sortOrder)) return 1
            if (isNaN(b.sortOrder)) return -1
            const result = a.sortOrder - b.sortOrder
            if (result !== 0) return result
          }
          // if (sortOrder !== 0) return sortOrder
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
        return templates
      },
      isRaceResult () {
        let roles = this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] &&
          this.$keycloak.resourceAccess['webcg-studio'].roles
        roles = roles && roles.length > 0 ? roles : Vue.prototype.$env.DEFAULT_ROLES
        return roles.indexOf('race-result') >= 0
      },
      hasLibraryRole () {
        const selectedAccount = this.$store.getters.selectedAccount
        const templateLibraryPolicies = selectedAccount &&
          selectedAccount.policies &&
          selectedAccount.policies.templateLibrary &&
          selectedAccount.policies.templateLibrary.allow
        if (templateLibraryPolicies && templateLibraryPolicies.length > 0) {
          return templateLibraryPolicies.some(p => p.startsWith('library:'))
        }
        let roles = this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] &&
          this.$keycloak.resourceAccess['webcg-studio'].roles
        roles = roles && roles.length > 0 ? roles : Vue.prototype.$env.DEFAULT_ROLES
        if (typeof roles === 'string') {
          try {
            roles = JSON.parse(roles)
          } catch (e) {}
        }
        return roles.some(p => p.startsWith('library:'))
      },
      isUiaa () {
        let roles = this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] &&
          this.$keycloak.resourceAccess['webcg-studio'].roles
        roles = roles && roles.length > 0 ? roles : Vue.prototype.$env.DEFAULT_ROLES
        return roles.indexOf('uiaa') >= 0
      },
      albums () {
        return this.$store.getters.albums()
      },
      datasets () {
        const datasets = this.$store.getters.datasets()
        datasets.sort((a, b) => {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
        return datasets
      },
      templates () {
        const templates = this.$store.getters.templates()
        templates.sort(function (a, b) {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
        return templates
      },
      folders () {
        // Group templates
        const folders = this.templates.reduce((res, template) => {
          const name = String(template.folder || '').trim()
          res[name] = (res[name] || []).concat([template])
          return res
        }, {})
        // Sort keys
        let keys = Object.keys(folders).sort()
        return keys.reduce((res, name) => {
          res[name] = folders[name]
          return res
        }, {})
      },
      windows () {
        return this.$store.getters.windows()
      },
      username () {
        return this.$keycloak.user.username
      },
      email () {
        return this.$keycloak.user.email
      }
    },
    methods: {
      openTemplateSelection () {
        this.$store.dispatch(action.WINDOW_CREATE, {
          componentType: 'template-library',
          title: 'Template Library',
          data: {}
        })
      },
      addAlbum () {
        this.$store.dispatch(action.ALBUM_CREATE, {componentType: 'album-window'})
      },
      openAlbum (albumId) {
        this.$store.dispatch(action.ALBUM_OPEN, {albumId})
      },
      addDatasetExcel () {
        this.$store.dispatch(action.DATASET_CREATE, {componentType: 'dataset-window'})
      },
      addDatasetRaceResult (componentType) {
        this.$store.dispatch(action.DATASET_CREATE, {componentType})
      },
      addDatasetUiaa (componentType) {
        this.$store.dispatch(action.DATASET_CREATE, {componentType})
      },
      openDataset (datasetId) {
        this.$store.dispatch(action.DATASET_OPEN, {datasetId})
      },
      addTemplate (templateDefinition) {
        this.$store.dispatch(action.TEMPLATE_CREATE, templateDefinition)
      },
      openTemplate (templateId) {
        this.$store.dispatch(action.TEMPLATE_OPEN, {templateId})
      },
      addProducer (title, channelId) {
        this.$store.dispatch(action.WINDOW_CREATE, {
          componentType: 'producer-window',
          title,
          data: {channelId, contentId: channelId}
        })
      },
      openWindow (windowId) {
        this.$store.dispatch(mutation.WINDOW_OPEN, {windowId})
      },
      logout () {
        this.$keycloak.logout()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/layout/navbar.vue